import { render, staticRenderFns } from "./ClientMenu.vue?vue&type=template&id=2f05a801&scoped=true&"
import script from "./ClientMenu.vue?vue&type=script&lang=js&"
export * from "./ClientMenu.vue?vue&type=script&lang=js&"
import style0 from "./ClientMenu.vue?vue&type=style&index=0&id=2f05a801&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f05a801",
  null
  
)

export default component.exports